module.exports = __webpack_public_path__ + "83239c64d8465cf22350b1555bd17884.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huadongkeji_1.png
// module id = 298
// module chunks = 3